/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { HomePageDataBlockJournal } from './HomePageDataBlockJournal'
import {
  HomePageDataBlockJournalFromJSON,
  HomePageDataBlockJournalFromJSONTyped,
  HomePageDataBlockJournalToJSON,
} from './HomePageDataBlockJournal'

/**
 *
 * @export
 * @interface HomePageData
 */
export interface HomePageData {
  /**
   *
   * @type {HomePageDataBlockJournal}
   * @memberof HomePageData
   */
  blockJournal: HomePageDataBlockJournal
}

/**
 * Check if a given object implements the HomePageData interface.
 */
export function instanceOfHomePageData(value: object): value is HomePageData {
  if (!('blockJournal' in value) || value['blockJournal'] === undefined)
    return false
  return true
}

export function HomePageDataFromJSON(json: any): HomePageData {
  return HomePageDataFromJSONTyped(json, false)
}

export function HomePageDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): HomePageData {
  if (json == null) {
    return json
  }
  return {
    blockJournal: HomePageDataBlockJournalFromJSON(json['blockJournal']),
  }
}

export function HomePageDataToJSON(value?: HomePageData | null): any {
  if (value == null) {
    return value
  }
  return {
    blockJournal: HomePageDataBlockJournalToJSON(value['blockJournal']),
  }
}
